/* import __COLOCATED_TEMPLATE__ from './index.hbs'; */
import Component from '@glimmer/component';

interface LearnWebhooksModalArgs {
  onTrackClick: (destination: string) => unknown;
  onTrackVideo: () => unknown;
}

export default class LearnWebhooksModal extends Component<LearnWebhooksModalArgs> {
  readonly learnAboutWebhooksModalExamples = [
    {
      url: 'https://customer.io/docs/stripe-data-campaign',
      logoUrl: new URL('cio/assets/images/data-campaigns/stripe.png', import.meta.url).toString(),
      logoAlt: 'Stripe',
      label: 'Message people who subscribe to your service',
    },
    {
      url: 'https://customer.io/docs/satismeter-data-campaign',
      logoUrl: new URL('cio/assets/images/data-campaigns/satismeter.png', import.meta.url).toString(),
      logoAlt: 'Satismeter',
      label: 'Follow up on NPS responses',
    },
    {
      url: 'https://customer.io/docs/zendesk-data-campaign',
      logoUrl: new URL('cio/assets/images/data-campaigns/zendesk.svg', import.meta.url).toString(),
      logoAlt: 'Zendesk',
      label: 'Notify team of high priority support ticket',
    },
  ];
}
